var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCF5F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_7391)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.125C12.2071 9.125 12.375 9.29289 12.375 9.5V12.5C12.375 12.7071 12.2071 12.875 12 12.875C11.7929 12.875 11.625 12.7071 11.625 12.5V9.5C11.625 9.29289 11.7929 9.125 12 9.125Z",
    fill: "#FF4336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2559 14.2207C12.4098 14.3593 12.4223 14.5964 12.2837 14.7503L12.2787 14.7559C12.1402 14.9098 11.9031 14.9223 11.7491 14.7837C11.5952 14.6452 11.5827 14.4081 11.7213 14.2541L11.7263 14.2486C11.8648 14.0946 12.1019 14.0822 12.2559 14.2207Z",
    fill: "#FF4336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.375C9.44568 7.375 7.375 9.44568 7.375 12C7.375 14.5543 9.44568 16.625 12 16.625C14.5543 16.625 16.625 14.5543 16.625 12C16.625 9.44568 14.5543 7.375 12 7.375ZM6.625 12C6.625 9.03147 9.03147 6.625 12 6.625C14.9685 6.625 17.375 9.03147 17.375 12C17.375 14.9685 14.9685 17.375 12 17.375C9.03147 17.375 6.625 14.9685 6.625 12Z",
    fill: "#FF4336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_7391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublished);
export default __webpack_public_path__ + "static/media/unpublished.7b204271516752b39153e09cd776f648.svg";
export { ForwardRef as ReactComponent };